// extracted by mini-css-extract-plugin
module.exports = {"content":"_footer_content__3TEPQ"};